// Dropify on every file input flagged with `data-dropify-auto`. Opt-in on purpose:
// the other dropify fields of the app are initialized by their own page controller
// with their own options, and must not be touched here.
export function bindDropify(input) {
  const $input = $(input);

  if (!$input.length || $input.data("dropify")) {
    return null;
  }

  return $input.dropify({
    messages: {
      default: I18n.t("plugins.dropify.messages.default"),
      replace: I18n.t("plugins.dropify.messages.replace"),
      remove: I18n.t("plugins.dropify.messages.remove"),
      error: I18n.t("plugins.dropify.messages.error")
    },
    error: {
      fileSize: I18n.t("plugins.dropify.error.fileSize"),
      fileExtension: I18n.t("plugins.dropify.error.fileExtension")
    }
  });
}

export function initDropifyFields(root = document) {
  root.querySelectorAll("[data-dropify-auto]").forEach((input) => bindDropify(input));
}

// Turbolinks replaces the body on navigation, so re-run on every page load.
["DOMContentLoaded", "turbolinks:load"].forEach((event) => {
  document.addEventListener(event, () => initDropifyFields());
});
